import { X } from 'lucide-react';

interface ShortcutDef {
  keys: string[];
  description: string;
}

const SHORTCUTS: ShortcutDef[] = [
  { keys: ['Space'], description: 'Play / pause' },
  { keys: ['K'], description: 'Play / pause' },
  { keys: ['M'], description: 'Mute / unmute' },
  { keys: ['F'], description: 'Toggle fullscreen' },
  { keys: ['↑'], description: 'Volume up' },
  { keys: ['↓'], description: 'Volume down' },
  { keys: ['←'], description: 'Seek backward 10s' },
  { keys: ['→'], description: 'Seek forward 10s' },
  { keys: ['?'], description: 'Show / hide shortcuts' },
  { keys: ['Shift', 'R'], description: 'Reload stream' },
  { keys: ['Esc'], description: 'Close this dialog' },
];

export function KeyboardHelp({ open, onClose }: { open: boolean; onClose: () => void }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Keyboard shortcuts"
    >
      <div
        className="bg-bg-elevated border border-border rounded-lg shadow-2xl w-full max-w-md mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h2 className="text-base font-semibold">Keyboard Shortcuts</h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="p-1 rounded hover:bg-bg-hover transition-colors text-text-muted"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <ul className="p-2 max-h-[70vh] overflow-y-auto">
          {SHORTCUTS.map((s) => (
            <li
              key={s.keys.join('+')}
              className="flex items-center justify-between gap-4 px-3 py-2 rounded hover:bg-bg-hover transition-colors"
            >
              <span className="text-sm text-text">{s.description}</span>
              <span className="flex items-center gap-1">
                {s.keys.map((k) => (
                  <kbd
                    key={k}
                    className="inline-flex items-center justify-center min-w-[1.75rem] h-7 px-2 text-xs font-mono font-semibold bg-bg-hover border border-border rounded text-text"
                  >
                    {k}
                  </kbd>
                ))}
              </span>
            </li>
          ))}
        </ul>
        <div className="px-4 py-2.5 border-t border-border text-xs text-text-muted">
          Tip: shortcuts only act when a channel is playing. Type in the search bar freely.
        </div>
      </div>
    </div>
  );
}
